// Founding-partner access on the client (ADR-0029).
//
// The backend decides: login and GET /auth/me return `user.foundingPartner`
// ({ endsAt, endsOnLabel, ended } or null), and a write after the end date
// returns 402 FOUNDING_PERIOD_ENDED. These constants connect the API client,
// which sees that error, to the app shell, which shows the upgrade prompt.

/** Error code the backend returns (402) for writes after founding access ends. */
export const FOUNDING_PERIOD_ENDED = 'FOUNDING_PERIOD_ENDED'

/** Window event fired when any request hits that error. */
export const FOUNDING_PERIOD_ENDED_EVENT = 'l2l:founding-period-ended'

/** Where the upgrade prompt sends the user. */
export const UPGRADE_PATH = '/subscription'
